import React, { Component } from 'react';
import _ from "underscore";
import { observer } from 'mobx-react';
import { Button, Input, message } from 'utils/ui';
import { sha512 } from 'hash-anything';
import { loginUser } from "../api_calls/user";
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';
import FormField from '../common/FormField';

const headerFontSize = "14pt";

@observer(["UserStore", "CustomRouter"])
class LoginButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            password: "",
            hashPass: "",
            family: "",
            loginModalIsOpen: false,
            submitting: false,
            buttons: <div>
                <Button style={_.extend(this.props.style || {}, { marginLeft: "4px", backgroundColor: "#a1e0ff", borderRadius: "40px", color: 'white', fontWeight: "bold" })} size="large" onClick={() => { this.setState({ loginModalIsOpen: true, registerModalIsOpen: false }) }}>Log In</Button>
            </div>
        };
        this.closeLoginModal = this.closeLoginModal.bind(this);
        this.submitLogin = this.submitLogin.bind(this);
        this.handleEnterKey = this.handleEnterKey.bind(this);
    }

    closeLoginModal() {
        this.setState({ loginModalIsOpen: false });
    }

    componentDidMount() {
        document.addEventListener("keyup", this.handleEnterKey);
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.handleEnterKey);
    }

    handleEnterKey(event) {
        if (event.key !== "Enter") return;

        if (this.state.loginModalIsOpen) {
            this.submitLogin();
        }
    }

    async submitLogin() {
        const { UserStore } = this.props;
        let email = (this.state.email || "").trim();
        let passHash = this.state.hashPass;

        if (this.state.submitting) {
            return;
        }

        if (email === "") {
            message.warning("Please enter your email.");
            return;
        }

        if (passHash === "") {
            message.warning("Please enter your password.");
            return;
        }

        this.setState({ submitting: true });
        const response = await loginUser(email, passHash);

        if (!response || !response.success) {
            if (response && (response.status === 401 || response.status === 403)) {
                message.error("Email or password does not match database.");
            } else {
                message.error("Unable to log in right now. Please try again.");
            }
            this.setState({ submitting: false });
            return;
        }

        let inviteId = this.props.CustomRouter && this.props.CustomRouter.router.params && this.props.CustomRouter.router.params.inviteId;
        await UserStore.handleLoggedIn(response.data, inviteId);

        this.setState({ loginModalIsOpen: false, submitting: false });
    }

    render() {
        const submitButtonStyles = {
            width: '100%',
            height: '40px',
            backgroundColor: '#F6D55C',
            borderRadius: '20px',
            border: 'none',
            color: '#3A3A3A',
            fontWeight: 'bold',
            fontSize: '16px'
        };
        return (
            <div>
                <ModalShell
                    isOpen={this.state.loginModalIsOpen}
                    onRequestClose={this.closeLoginModal}
                    contentLabel="Login Modal"
                    className="register-modal"
                    overlayClassName="register-modal-overlay"
                    maxWidth={420}>
                    <ModalBody title="Log In" subtitle="Welcome back">
                    <div className="AppFont" style={{ fontSize: headerFontSize, color: "#222", textAlign: "center" }}>
                        <FormField label="Email" style={{ marginBottom: '1rem' }}>
                            <Input
                                type="email"
                                placeholder="Enter your email"
                                value={this.state.email}
                                onChange={(e) => { this.setState({ email: e.target.value }) }}
                            />
                        </FormField>

                        <FormField label="Password" style={{ marginBottom: '1rem' }}>
                            <Input
                                id="password-login"
                                type="password"
                                placeholder="Enter your password"
                                value={this.state.password}
                                onChange={(e) => {
                                    const password = e.target.value;
                                    this.setState({
                                        password,
                                        hashPass: sha512(password)
                                    });
                                }}
                            />
                        </FormField>
                        
                        <Button 
                            style={submitButtonStyles}
                            className="btn-submit ui-btn-success"
                            id="submitBtn-login"
                            size="large"
                            disabled={this.state.submitting}
                            onClick={this.submitLogin}
                        >
                            {this.state.submitting ? "Logging In..." : "Submit"}
                        </Button>
                    </div>
                    </ModalBody>
                </ModalShell>
                {this.state.buttons}
            </div>
        );
    }
}

export default LoginButton;